<template>
  <div>
    <TopAppBarDrawer></TopAppBarDrawer>
    <main class="main-wrapper flex-grow-1 bg-documentGray h-full">
      <div class="d-flex align-items-center bg-white fix-header-title">
        <div class="t-headline13 t-color-headlineBlack pda-14 t-center  flex-grow-1 ">
          <div class="font-m">{{ this.$t('1736') }}</div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="container container--narrow mgt-76 pdb-50">
        <div class="position-relative mdc-card pdb-24 mgb-50">
          <div v-if="personalInfo" class="info-avatar-container cursor-pointer" @click.prevent="openPattenDialog" @keypress.prevent="openPattenDialog">
            <UserImgProfile :data="personalInfo" :size="'xxl'" class="myInfo-avatar" />
            <img alt="" class="circle w-30 h-30 myInfo-setting-icon" src="/images/myinformation/info-setting.png" tabindex="0">
          </div>
          <div class="t-subtitle1 font-b t-center l-spacing6">{{
              (personalInfo && personalInfo.name) ? $t('3437', {
                first: personalInfo.name.first,
                last: personalInfo.name.last
              }) : ''
            }}
          </div>
          <div class="mgt-10 t-body3 t-color-bodyGrayA font-r t-center">{{
              personalInfo ? personalInfo.userId : ''
            }}
          </div>
          <div class="d-flex user-list-info justify-content-center mgt-8">
            <div class="t-body3  t-color-bodyGrayA font-r pdr-8 mgr-8 font-r">
              {{ personalInfo ? personalInfo.dutyName : '' }}
            </div>
            <div class="t-body3  t-color-bodyGrayA font-r font-r">{{
                personalInfo ? personalInfo.responsibilityName : ''
              }}
            </div>
          </div>
        </div>

        <!-- 학습 현황 -->
        <div class="t-headline10 font-b mgb-16">{{ $t('1737') }}</div>
        <MyInformationCurrentStudy
          :goToMicroLearning="goToMicroLearning"
          :microLearning="microLearning"
          :goToLearning="goToLearning"
          :learning="learning"
          :goToCompletion="goToCompletion"
          :completion="completion"
          :goToMyTest="goToMyTest"
          :eaxmTest="eaxmTest"
          :goToMySurvey="goToMySurvey"
          :survey="survey"
        />

        <!-- 하단 리스트 항목 -->
        <div class="mdc-card mgt-50">
          <ul class="mdc-list">
            <li class="mdc-list-item pdl-24 pdt-16 pdb-16" tabindex="0" @click.prevent="goToLicense" @keypress.prevent="goToLicense">
              <span class="mdc-list-item__ripple"></span>
              <img alt="" class="w-24 h-24 mgr-32 d-inline" src="/images/myinformation/cirtificate-icon.svg">
              <div class="mdc-list-item__text t-body1 t-color-bodyGrayA font-r l-spacing48">{{ $t('1742') }}</div>
            </li>
            <li class="mdc-list-divider" role="separator"></li>
            <li class="mdc-list-item pdl-24 pdt-16 pdb-16" tabindex="0" @click.prevent="goToReport" @keypress.prevent="goToReport">
              <span class="mdc-list-item__ripple"></span>
              <i class="mdc-list-item__graphic material-icons t-color-iconInactive mgr-32">check_circle_outline</i>
              <div class="mdc-list-item__text t-body1 t-color-bodyGrayA font-r l-spacing48">{{ $t('1743') }}</div>
            </li>
            <li class="mdc-list-divider" role="separator"></li>
            <li class="mdc-list-item pdl-24 pdt-16 pdb-16" tabindex="0" @click.prevent="goToMemberDetail" @keypress.prevent="goToMemberDetail">
              <span class="mdc-list-item__ripple"></span>
              <img alt="" class="w-24 h-24 mgr-32 d-inline" src="/images/myinformation/user-edit.svg">
              <div class="mdc-list-item__text t-body1 t-color-bodyGrayA font-r l-spacing48">{{ $t('1744') }}</div>
            </li>
            <li class="mdc-list-divider" role="separator"></li>
            <li class="mdc-list-item pdl-24 pdt-16 pdb-16" tabindex="0" @click.prevent="goToChangePassord" @keypress.prevent="goToChangePassord">
              <span class="mdc-list-item__ripple"></span>
              <i class="mdc-list-item__graphic material-icons t-color-iconInactive mgr-32">lock</i>
              <div class="mdc-list-item__text t-body1 t-color-bodyGrayA font-r l-spacing48">{{ $t('1745') }}</div>
            </li>
          </ul>
        </div>
      </div>
    </main>
    <profile-photo-type></profile-photo-type>
  </div>
</template>

<script>
// Components/Mixin/Extend/API define
import {MDCDialog} from '@material/dialog';
import {MDCRipple} from '@material/ripple'

import memberApi from '@/api/memberApi.js'
import licenseApi from "@/api/licenseApi.js";
import learnApi from '@/api/learnApi.js'
import microLearnApi from '@/api/microLearnApi.js'
import examApi from '@/api/examApi.js'
import surveyApi from '@/api/surveyApi.js'
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import ProfilePhotoType from "@/components/common/ProfilePhotoType";

export default {
  name: 'MemberDetail',

  data() {
    return {
      personalInfo: null,
      profileImage: null,
      phoneNo: null,
      memberId: '',
      microLearning: 0,
      learning: 0,
      completion: 0,
      eaxmTest: 0,
      survey: '0',
      screenSize: "",
      innerHeight: "",
      firstCharOfNames: localStorage.getItem('firstChar'),
      bgColorOfName: localStorage.getItem('bgColors'),
    }
  },

  components: {
    TopAppBarDrawer,
    'profile-photo-type': ProfilePhotoType,
    MyInformationCurrentStudy: () => import("./MyInformationCurrentStudy.vue"),
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
  },

  created() {
    window.addEventListener("resize", this.myEventHandler);
  },

  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },

  mounted() {
    if (window.innerHeight > 640) {
      this.screenSize = "h-full";
    } else {
      this.screenSize = "";
    }

    this.fatchData()
    this.setMaterialUi()
    this.pattenDialog = new MDCDialog(document.querySelector('.mdc-dialog'))
    this.pattenDialog.listen('MDCDialog:opened', () => {

    })
  },

  methods: {
    fatchData() {
      memberApi.getMemberInfo().then((response) => {
        this.personalInfo = response.data.data
        this.profileImage = this.personalInfo ? this.personalInfo.profile : ''
        this.phoneNo = this.personalInfo ? this.personalInfo.phone : ''
        this.memberId = this.personalInfo.id
      })

      let learningParams = this.learningSetParams()
      let completionParams = this.completionSetParams()
      let examParams = this.examSetParams()

      //(get Ongoing lesson count)
      microLearnApi.learnCountLesson(learningParams).then((response) => {
        this.microLearning = response.data.data
      }).catch(() => {

      })

      //(get Ongoing lesson count)
      learnApi.learnCountLesson(learningParams).then((response) => {
        this.learning = response.data.data
      }).catch(() => {

      })

      //(get completed lesson count)
      learnApi.learnCountLesson(completionParams).then((response) => {
        this.completion = response.data.data
      }).catch(() => {

      })

      // 단독 시험 목록(get my Exam count)
      examApi.myEaxmCount(examParams).then((response) => {
        this.eaxmTest = response.data.data
        //this.eaxmTest = responseData? responseData.totalElements : 0
      }).catch(() => {

      })

      // 나의 설문 목록(get my independent survey count)
      surveyApi.surveyCount().then((response) => {
        this.survey = response.data.data
      }).catch((err) => {

      })
    },

    goToMicroLearning() {
      localStorage.setItem("learning", "myinformation");
      this.$router.push({name: 'MicroDegreeList', query: {status: 'LEARNING'}})
    },

    goToLearning() {
      //this.$router.push('/learn?status=LEARNING')
      localStorage.setItem("learning", "myinformation");
      this.$router.push({name: 'LearnList', query: {status: 'LEARNING'}})
    },

    goToCompletion() {
      localStorage.setItem("learning", "myinformation");
      this.$router.push({name: 'LearnList', query: {status: 'COMPLETION'}})
    },

    goToMyTest() {
      localStorage.setItem("mytest", "myinformation");
      this.$router.push({name: 'IndependentExam', query: {listType: 'my'}})
    },

    goToMySurvey() {
      localStorage.setItem("mysurvey", "myinformation");
      this.$router.push({name: 'IndependentSurvey', query: {listType: 'my'}})
    },

    goToLicense() {
      let params = {
        "memberId": this.memberId
      };
      licenseApi.getLicenseResponsibility(params).then((response) => {
        if (response.data.data.type.translate == 'NONE') {
          this.$alert({
            title: "",
            content: this.$t("3094"),
            accept: this.$t("3095")
          })
              .then(() => {
              }).catch(() => {
          });
        } else {
          this.$router.push({
            name: "License",
          })
        }
      }).then((error) => {
        console.log(error);
      });
    },

    goToReport() {
      this.$router.push({
        name: "Report",
      })
    },

    goToMemberDetail() {
      this.$router.push({
        name: "MemberDetail",
      })
    },

    goToChangePassord() {
      localStorage.setItem("changepassword", "myinformation");
      this.$router.push({
        name: "MyInfoChangePassword",
      })
    },

    openPattenDialog() {
      this.pattenDialog.open()
    },

    addMobileNo() {
      this.$router.push('myphone')
    },

    learningSetParams() {
      const params = {
        status: 'LEARNING',
        name: '',
      }
      return params
    },

    completionSetParams() {
      const params = {
        status: 'COMPLETION',
        name: '',
      }
      return params
    },

    examSetParams() {
      const params = {
        application: true,
      }
      return params
    },

    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function (el) {
        let button = new MDCRipple.attachTo(el)
        return button
      })
    },
    
    myEventHandler(e) {
      if (e.target.outerHeight > 640 || this.innerHeight > 640) {
        this.screenSize = "h-full";
      } else {
        this.screenSize = "";
      }
    },
  }

}
</script>